"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComboGame = function () {
  function ComboGame(level, columns, tileColor) {
    _classCallCheck(this, ComboGame);

    this.tileColor = tileColor;
    this.level = level;
    this.columns = columns;
  }

  _createClass(ComboGame, [{
    key: "setTileColor",
    value: function setTileColor(tileColor) {
      this.tileColor = tileColor;
    }
  }, {
    key: "randomizeHealth",
    value: function randomizeHealth() {
      return Math.floor(Math.random() * (10 * ((10 + this.level) / 15))) + 1;
    }
  }, {
    key: "randomizeMultiplier",
    value: function randomizeMultiplier(health, force) {
      // eslint-disable-line
      var random = Math.floor(Math.random() * 100) + 1;
      if (health <= 3) return 1;
      if (random === 50) return 2;
      if (random === 99) return 3;
      if (force) return 2;
      return 1;
    }
  }, {
    key: "setAtleastOneMultiplier",
    value: function setAtleastOneMultiplier(tiles, level) {
      var _this = this;

      var multipliers = Math.ceil(level / 10);

      var enoughMultipliers = tiles.filter(function (x) {
        return x.multiplier > 1;
      }).length >= multipliers;
      if (!enoughMultipliers) {
        var _loop = function _loop(i) {
          var multiTiles = tiles.filter(function (x) {
            return x.health > 3 && x.multiplier === 1;
          });
          var random = Math.floor(Math.random() * (multiTiles.length - 1 + 1));
          var tile = multiTiles[random];
          var selectedTile = tiles.find(function (x) {
            return x.id === tile.id;
          });

          selectedTile.multiplier = _this.randomizeMultiplier(tile.health, true);
        };

        for (var i = 0; i < multipliers; i += 1) {
          _loop(i);
        }
      }

      if (level % 7 === 0) {
        var sortedTiles = tiles.concat().sort(function (a, b) {
          return b.health - a.health;
        });
        var powerupTile = tiles.find(function (x) {
          return x.id === sortedTiles[0].id;
        });
        powerupTile.multiplier = -1;
      }

      return tiles;
    }
  }, {
    key: "newGame",
    value: function newGame() {
      var row = 1;
      var column = 1;
      var tiles = [];

      for (var i = 1; i <= 56; i += 1) {
        // const tileHealth = this.randomizeHealth();
        tiles.push({
          id: i,
          position: { row: row, column: column },
          alive: true,
          health: 0,
          score: 0,
          multiplier: 0
        });

        column += 1;

        if (column > this.columns) {
          row += 1;
          column = 1;
        }
      }
      this.setAllAsAlive(tiles, 1);
      return tiles;
      // return this.setAtleastOneMultiplier(tiles, this.level);
    }
  }, {
    key: "setAllAsAlive",
    value: function setAllAsAlive(tiles, level) {
      var _this2 = this;

      this.level = level;

      new Promise(function (resolve) {
        var totalHealth = 200 + level * 15;

        for (var i = 0; i < tiles.length; i += 1) {
          tiles[i].health = 0; //eslint-disable-line
        }

        while (totalHealth > 0) {
          for (var _i = 0; _i < tiles.length; _i += 1) {
            var health = ComboGame.randomBetween(1, totalHealth / tiles.length);
            tiles[_i].health += health; //eslint-disable-line
            tiles[_i].score = tiles[_i].health; //eslint-disable-line
            tiles[_i].multiplier = _this2.randomizeMultiplier(tiles[_i].health); //eslint-disable-line
            totalHealth -= health;
          }
        }
        resolve();
      }).then(function () {
        _this2.setAtleastOneMultiplier(tiles, level);
        tiles.forEach(function (tile, index) {
          setTimeout(function () {
            tile.alive = true; //eslint-disable-line
          }, 10 * index);
        });
      });
    }
  }], [{
    key: "randomBetween",
    value: function randomBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min); //eslint-disable-line
    }
  }]);

  return ComboGame;
}();

exports.default = ComboGame;


//////////////////
// WEBPACK FOOTER
// ../combo-logic/lib/comboGame.js
// module id = 39
// module chunks = 1